import { getLabelContent } from 'actions'
import CommonPrintModal from 'components/common/CommonPrintModal'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ILabelPrintProps } from './LabelPrintTypes'

class LabelPrint extends Component<ILabelPrintProps> {
	componentDidMount(): void {
		const { idOperation } = this.props
		this.props.getLabelContent({ idOperacion: idOperation })
	}

	render() {
		const { labelContent, handleCloseModal } = this.props
		return (
			<CommonPrintModal
				fileContent={labelContent}
				handleCloseModal={handleCloseModal}
			/>
		)
	}
}

const mapStateToProps = ({ generateForm }: any) => {
	const { labelContent } = generateForm
	return { labelContent }
}

const mapDispatchToProps = {
	getLabelContent
}

export default connect(mapStateToProps, mapDispatchToProps)(LabelPrint)
